import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import SelectField from '@wix/da-ds/pkg/Dropdown/select/SelectField';
import { OriginalDeviationFieldName } from '../../types';

interface Props {}

const DeliveryTimeField: React.FC<Props> = () => {
  const { t } = useTranslation();
  const id = useId();
  const { control } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({
    name: OriginalDeviationFieldName.DELIVERY_TIME,
    control,
  });

  const numberOfDays = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 14, 21, 30, 45];
  const items = numberOfDays.map(days => ({
    label: t('originalDeviationPopup.form.deliveryTime.option.label', {
      count: days,
    }),
    value: days,
  }));

  return (
    <SelectField
      id={id}
      label={t('originalDeviationPopup.form.deliveryTime.label')}
      items={items}
      value={value}
      onSelect={onChange}
      withBlankOption={false}
    />
  );
};
DeliveryTimeField.displayName = 'DeliveryTimeField';

export default DeliveryTimeField;
